var _path, _path2, _path3, _path4, _path5, _path6, _path7, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoginPageImage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 551,
    height: 446,
    viewBox: "0 0 551 446",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.12
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2513_30134)"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 40,
    viewBox: "0 0 1443 165",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M137.189 0.973563L183.633 0.973145V19.7535L137.189 19.754C125.473 19.754 114.597 25.8351 108.461 35.8163L89.8876 66.0301C88.5348 68.2307 87.034 70.3095 85.4024 72.2569L137.092 72.2568C137.124 72.2568 137.157 72.2567 137.189 72.2567H183.254V91.0371H137.189C137.164 91.0371 137.138 91.0372 137.112 91.0372C125.425 91.064 114.583 97.1403 108.461 107.1L89.8874 137.313C80.3347 152.853 63.4008 162.32 45.1597 162.32H0.480053L0.480054 143.54L45.1597 143.54C56.8759 143.54 67.7525 137.459 73.8883 127.478L92.4615 97.2643C93.8144 95.0637 95.3152 92.9848 96.9468 91.0373L0.483791 91.0375V91.0369H0.47998L0.479981 72.2572H0.483792V72.2571L45.2695 72.257C56.9439 72.2192 67.7719 66.1449 73.8885 56.1949L92.4617 25.9811C102.015 10.4414 118.948 0.973561 137.189 0.973563Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M290.659 161.964V2.97007H390.825V26.592H315.189V138.342H390.825V161.964H290.659ZM301.788 92.2339V68.6119H378.333V92.2339H301.788Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M536.022 164.235C523 164.235 511.492 161.661 501.498 156.513C491.655 151.365 483.176 143.642 476.059 133.345L492.867 114.039C500.287 124.638 507.403 131.982 514.217 136.071C521.031 140.159 529.133 142.203 538.521 142.203C544.275 142.203 549.499 141.295 554.193 139.478C558.887 137.661 562.597 135.162 565.323 131.982C568.048 128.803 569.411 125.168 569.411 121.08C569.411 118.354 568.957 115.78 568.048 113.357C567.14 110.935 565.701 108.739 563.733 106.77C561.916 104.802 559.493 102.985 556.464 101.319C553.587 99.6536 550.18 98.2151 546.243 97.0037C542.306 95.6409 537.764 94.5052 532.615 93.5967C524.439 91.931 517.322 89.7354 511.265 87.0098C505.208 84.2842 500.135 80.8772 496.047 76.7887C491.958 72.7003 488.93 68.0819 486.961 62.9335C484.993 57.6337 484.009 51.7283 484.009 45.2171C484.009 36.586 486.431 28.9391 491.277 22.2765C496.122 15.6139 502.634 10.3898 510.81 6.60423C519.139 2.66723 528.451 0.69873 538.748 0.69873C551.013 0.69873 561.689 3.12149 570.774 7.96703C580.011 12.6611 587.279 19.5509 592.579 28.6363L575.317 45.6713C570.774 38.2516 565.323 32.5732 558.963 28.6363C552.755 24.6993 545.789 22.7308 538.067 22.7308C532.161 22.7308 527.013 23.6393 522.621 25.4564C518.23 27.2734 514.747 29.8476 512.173 33.1789C509.75 36.3588 508.539 40.1444 508.539 44.5357C508.539 47.7155 509.145 50.6683 510.356 53.3939C511.568 55.9681 513.385 58.3151 515.807 60.4351C518.382 62.4036 521.789 64.2206 526.028 65.8863C530.268 67.4005 535.341 68.7633 541.246 69.9747C549.575 71.7918 556.994 74.1388 563.506 77.0159C570.017 79.7415 575.544 82.9971 580.086 86.7827C584.629 90.5682 588.036 94.8081 590.307 99.5022C592.73 104.196 593.942 109.269 593.942 114.72C593.942 124.866 591.595 133.648 586.9 141.068C582.206 148.487 575.544 154.242 566.913 158.33C558.282 162.267 547.985 164.235 536.022 164.235Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M756.575 164.235C745.067 164.235 734.316 162.191 724.322 158.103C714.328 153.863 705.546 148.033 697.974 140.613C690.403 133.194 684.498 124.563 680.258 114.72C676.17 104.726 674.125 93.9752 674.125 82.4671C674.125 71.1104 676.17 60.5108 680.258 50.6683C684.498 40.8258 690.328 32.2704 697.747 25.0021C705.318 17.5824 714.101 11.8283 724.095 7.7399C734.089 3.65148 744.84 1.60727 756.348 1.60727C764.373 1.60727 772.172 2.74293 779.743 5.01427C787.465 7.28562 794.431 10.4655 800.639 14.5539C806.848 18.6423 811.92 23.3365 815.857 28.6363L799.958 45.2171C793.144 38.7059 786.027 33.7846 778.607 30.4533C771.339 27.122 763.919 25.4564 756.348 25.4564C748.171 25.4564 740.6 26.8949 733.635 29.7719C726.821 32.649 720.764 36.6617 715.464 41.81C710.315 46.9584 706.303 53.0153 703.426 59.9808C700.549 66.7948 699.11 74.2903 699.11 82.4671C699.11 90.3411 700.624 97.8365 703.653 104.953C706.681 111.919 710.845 118.051 716.145 123.351C721.596 128.651 727.805 132.815 734.77 135.844C741.887 138.872 749.383 140.386 757.257 140.386C763.162 140.386 768.765 139.554 774.065 137.888C779.364 136.071 784.058 133.572 788.147 130.392C792.235 127.213 795.415 123.578 797.686 119.49C799.958 115.25 801.094 110.783 801.094 106.089V101.546L804.5 104.726H755.894V80.4229H826.305C826.608 82.0885 826.835 83.7542 826.987 85.4198C827.138 86.9341 827.214 88.4483 827.214 89.9625C827.365 91.3253 827.441 92.6881 827.441 94.0509C827.441 104.499 825.624 114.039 821.99 122.67C818.356 131.15 813.283 138.494 806.772 144.702C800.412 150.91 792.917 155.756 784.286 159.239C775.806 162.57 766.569 164.235 756.575 164.235Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M916.165 161.964V2.97007H940.696V161.964H916.165ZM927.068 94.2781V70.6561H1009.06V94.2781H927.068ZM927.068 26.592V2.97007H1019.28V26.592H927.068Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1109.58 161.964V2.97007H1134.12V138.342H1208.62V161.964H1109.58Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1364.45 164.235C1353.25 164.235 1342.87 162.191 1333.33 158.103C1323.95 154.014 1315.69 148.336 1308.58 141.068C1301.61 133.648 1296.16 125.017 1292.22 115.174C1288.44 105.181 1286.55 94.2781 1286.55 82.4671C1286.55 70.6561 1288.44 59.8294 1292.22 49.9869C1296.16 39.993 1301.61 31.3619 1308.58 24.0936C1315.69 16.6738 1323.95 10.9198 1333.33 6.83136C1342.87 2.74294 1353.25 0.69873 1364.45 0.69873C1375.66 0.69873 1385.95 2.74294 1395.34 6.83136C1404.88 10.9198 1413.13 16.6738 1420.1 24.0936C1427.22 31.5133 1432.67 40.2201 1436.45 50.214C1440.39 60.0565 1442.36 70.8075 1442.36 82.4671C1442.36 94.1267 1440.39 104.953 1436.45 114.947C1432.67 124.79 1427.22 133.421 1420.1 140.841C1413.13 148.26 1404.88 154.014 1395.34 158.103C1385.95 162.191 1375.66 164.235 1364.45 164.235ZM1364.45 140.386C1372.17 140.386 1379.22 138.948 1385.58 136.071C1392.09 133.194 1397.69 129.181 1402.38 124.033C1407.08 118.733 1410.71 112.6 1413.29 105.635C1416.01 98.5179 1417.37 90.7954 1417.37 82.4671C1417.37 74.1388 1416.01 66.492 1413.29 59.5265C1410.71 52.4097 1407.08 46.277 1402.38 41.1286C1397.69 35.8288 1392.09 31.7404 1385.58 28.8634C1379.22 25.9864 1372.17 24.5478 1364.45 24.5478C1356.73 24.5478 1349.61 25.9864 1343.1 28.8634C1336.74 31.7404 1331.14 35.7531 1326.29 40.9015C1321.6 46.0499 1317.97 52.1825 1315.39 59.2994C1312.82 66.2648 1311.53 73.9874 1311.53 82.4671C1311.53 93.6724 1313.8 103.666 1318.34 112.449C1322.89 121.08 1329.1 127.894 1336.97 132.891C1344.99 137.888 1354.16 140.386 1364.45 140.386Z",
    fill: "white"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2513_30134)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M88.18 272.76L44.98 247.82C44.24 247.39 44.33 246.65 45.19 246.16L87.97 221.46C88.82 220.97 90.11 220.91 90.85 221.34L134.05 246.28C134.79 246.71 134.7 247.45 133.84 247.94L91.06 272.64C90.21 273.13 88.92 273.19 88.18 272.76Z",
    fill: "#0F6F00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.3999 285.55C88.6299 285.55 87.8899 285.39 87.3299 285.06L24.1399 248.58C23.5199 248.22 23.1799 247.7 23.1699 247.11C23.1699 246.44 23.6299 245.79 24.4399 245.32L87.0199 209.19C88.4199 208.38 90.4799 208.31 91.7099 209.02L154.9 245.5C155.52 245.86 155.86 246.38 155.86 246.97C155.86 247.64 155.4 248.29 154.59 248.76L92.0099 284.89C91.2499 285.33 90.2999 285.55 89.3899 285.55H89.3999ZM87.7999 284.25C88.7299 284.79 90.4499 284.71 91.5499 284.08L154.13 247.95C154.63 247.66 154.93 247.3 154.93 246.98C154.93 246.68 154.66 246.46 154.44 246.33L91.2499 209.85C90.3199 209.31 88.5999 209.39 87.4999 210.02L24.9199 246.15C24.4199 246.44 24.1199 246.8 24.1199 247.12C24.1199 247.42 24.3899 247.64 24.6099 247.77L87.7999 284.25Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.54 229.38V221.05H120.97L90.86 203.67C90.12 203.24 88.83 203.3 87.98 203.79L58 221.1H44.49V229.46C44.5 229.72 44.66 229.97 44.98 230.15L88.18 255.09C88.92 255.52 90.21 255.46 91.06 254.97L133.84 230.27C134.28 230.01 134.52 229.69 134.54 229.38Z",
    fill: "url(#paint0_linear_2513_30134)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.18 246.76L44.98 221.82C44.24 221.39 44.33 220.65 45.19 220.16L87.97 195.46C88.82 194.97 90.11 194.91 90.85 195.34L134.05 220.28C134.79 220.71 134.7 221.45 133.84 221.94L91.06 246.64C90.21 247.13 88.92 247.19 88.18 246.76Z",
    fill: "url(#paint1_linear_2513_30134)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.33 243.84L50.04 221.73C49.38 221.35 49.47 220.69 50.22 220.25L88.14 198.36C88.9 197.92 90.04 197.88 90.7 198.25L128.99 220.36C129.64 220.74 129.56 221.4 128.81 221.84L90.89 243.73C90.13 244.17 88.99 244.21 88.33 243.84Z",
    fill: "#0F6F00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.4299 241.98L53.2499 221.67C52.6499 221.32 52.7199 220.72 53.4199 220.31L88.2599 200.2C88.9499 199.8 90.0099 199.76 90.6099 200.1L125.79 220.41C126.39 220.76 126.32 221.36 125.62 221.77L90.7799 241.88C90.0899 242.28 89.0299 242.32 88.4299 241.98Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.7101 219.72L84.5901 217.35L86.8401 216.05L90.9501 218.43L88.7101 219.72Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.35 219.39L92.24 221.76L89.99 220.46L94.11 218.09L96.35 219.39Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.77 220.26L85.53 221.56L83.28 220.26L85.53 218.96L87.77 220.26Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.5401 224.74L93.2901 226.04L86.8101 222.3L89.0601 221L95.5401 224.74Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M482.22 321.07L439.02 296.13C438.28 295.7 438.37 294.96 439.23 294.47L482.01 269.77C482.86 269.28 484.15 269.22 484.89 269.65L528.09 294.59C528.83 295.02 528.74 295.76 527.88 296.25L485.1 320.95C484.25 321.44 482.96 321.5 482.22 321.07Z",
    fill: "#0F6F00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.44 332.27C482.7 332.27 481.99 332.12 481.44 331.8L420.9 296.84C420.3 296.49 419.97 295.99 419.97 295.42C419.97 294.77 420.42 294.14 421.19 293.69L481.15 259.07C482.5 258.29 484.48 258.22 485.66 258.9L546.2 293.86C546.8 294.21 547.13 294.71 547.13 295.28C547.13 295.93 546.68 296.56 545.91 297.01L485.95 331.63C485.22 332.05 484.31 332.26 483.43 332.26L483.44 332.27ZM483.68 259.39C482.97 259.39 482.2 259.56 481.62 259.9L421.66 294.52C421.19 294.79 420.91 295.13 420.91 295.43C420.91 295.71 421.16 295.91 421.37 296.03L481.91 330.99C482.8 331.5 484.43 331.43 485.48 330.82L545.44 296.2C545.91 295.93 546.19 295.59 546.19 295.29C546.19 295.01 545.94 294.81 545.73 294.68L485.19 259.73C484.79 259.5 484.25 259.39 483.68 259.39Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.58 278.81V270.48H515.01L484.9 253.1C484.16 252.67 482.87 252.73 482.02 253.22L452.04 270.53H438.53V278.89C438.54 279.15 438.7 279.4 439.02 279.58L482.22 304.52C482.96 304.95 484.25 304.89 485.1 304.4L527.88 279.7C528.32 279.44 528.56 279.12 528.58 278.81Z",
    fill: "#0F6F00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.22 296.19L439.02 271.25C438.28 270.82 438.37 270.08 439.23 269.59L482.01 244.89C482.86 244.4 484.15 244.34 484.89 244.77L528.09 269.71C528.83 270.14 528.74 270.88 527.88 271.37L485.1 296.07C484.25 296.56 482.96 296.62 482.22 296.19Z",
    fill: "url(#paint2_linear_2513_30134)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.22 296.19L439.02 271.25C438.28 270.82 438.37 270.08 439.23 269.59L482.01 244.89C482.86 244.4 484.15 244.34 484.89 244.77L528.09 269.71C528.83 270.14 528.74 270.88 527.88 271.37L485.1 296.07C484.25 296.56 482.96 296.62 482.22 296.19Z",
    fill: "url(#paint3_linear_2513_30134)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.37 293.27L444.08 271.16C443.43 270.78 443.51 270.12 444.26 269.68L482.18 247.79C482.94 247.35 484.08 247.31 484.74 247.68L523.03 269.79C523.68 270.17 523.6 270.83 522.85 271.27L484.93 293.16C484.17 293.6 483.03 293.64 482.37 293.27Z",
    fill: "#0F6F00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.47 291.42L447.29 271.11C446.69 270.76 446.76 270.16 447.46 269.75L482.3 249.64C482.99 249.24 484.05 249.2 484.65 249.54L519.83 269.85C520.43 270.2 520.36 270.8 519.66 271.21L484.82 291.32C484.13 291.72 483.07 291.76 482.47 291.42Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.75 269.16L478.63 266.78L480.88 265.49L484.99 267.86L482.75 269.16Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490.39 268.82L486.28 271.2L484.03 269.9L488.14 267.53L490.39 268.82Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M481.81 269.7L479.57 270.99L477.32 269.7L479.57 268.4L481.81 269.7Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489.57 274.18L487.33 275.48L480.85 271.74L483.1 270.44L489.57 274.18Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M528.59 259.28L510.21 259.39L484.89 244.77C484.15 244.34 482.86 244.4 482.01 244.89L456.34 259.71L438.52 259.82V270.64H438.53C438.57 270.87 438.73 271.09 439.02 271.25L482.22 296.19C482.96 296.62 484.25 296.56 485.1 296.07L527.88 271.37C528.27 271.15 528.49 270.87 528.56 270.59L528.59 270.57V259.27V259.28Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.58 260.35V252.02H515.01L484.9 234.64C484.16 234.21 482.87 234.27 482.02 234.76L452.04 252.07H438.53V260.43C438.54 260.69 438.7 260.94 439.02 261.12L482.22 286.06C482.96 286.49 484.25 286.43 485.1 285.94L527.88 261.24C528.32 260.98 528.56 260.66 528.58 260.35Z",
    fill: "#0F6F00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.22 277.73L439.02 252.79C438.28 252.36 438.37 251.62 439.23 251.13L482.01 226.43C482.86 225.94 484.15 225.88 484.89 226.31L528.09 251.25C528.83 251.68 528.74 252.42 527.88 252.91L485.1 277.61C484.25 278.1 482.96 278.16 482.22 277.73Z",
    fill: "url(#paint4_linear_2513_30134)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.37 274.81L444.08 252.7C443.43 252.32 443.51 251.66 444.26 251.22L482.18 229.33C482.94 228.89 484.08 228.85 484.74 229.22L523.03 251.33C523.68 251.71 523.6 252.37 522.85 252.81L484.93 274.7C484.17 275.14 483.03 275.18 482.37 274.81Z",
    fill: "#0F6F00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.47 272.96L447.29 252.65C446.69 252.3 446.76 251.7 447.46 251.29L482.3 231.18C482.99 230.78 484.05 230.74 484.65 231.08L519.83 251.39C520.43 251.74 520.36 252.34 519.66 252.75L484.82 272.86C484.13 273.26 483.07 273.3 482.47 272.96Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.75 250.7L478.63 248.32L480.88 247.02L484.99 249.4L482.75 250.7Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490.39 250.36L486.28 252.73L484.03 251.44L488.14 249.06L490.39 250.36Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M481.81 251.23L479.57 252.53L477.32 251.23L479.57 249.94L481.81 251.23Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489.57 255.72L487.33 257.01L480.85 253.27L483.1 251.98L489.57 255.72Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.3 430.71C388.61 430.71 387.93 430.53 387.32 430.18L351.86 409.71L352.33 408.89L387.79 429.36C388.72 429.9 389.88 429.9 390.81 429.36L549.21 337.91C549.43 337.78 549.56 337.55 549.56 337.3C549.56 337.05 549.43 336.82 549.21 336.69L512.97 315.76L513.44 314.94L549.68 335.87C550.2 336.17 550.5 336.7 550.5 337.3C550.5 337.9 550.19 338.43 549.68 338.73L391.28 430.18C390.67 430.53 389.98 430.71 389.3 430.71Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.51 352.88C88.63 352.88 87.76 352.66 86.98 352.21L0.75 302.46C0.28 302.19 0.01 301.71 0 301.17C0 300.63 0.28 300.15 0.74 299.88L57.57 267.07L58.04 267.89L1.21 300.7C0.96 300.84 0.94 301.08 0.94 301.17C0.94 301.26 0.97 301.5 1.21 301.64L87.45 351.38C88.72 352.12 90.3 352.11 91.57 351.38L108.97 341.34L109.44 342.16L92.04 352.2C91.26 352.65 90.38 352.88 89.51 352.88Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.14 224.94L240.56 85.98L238.68 85.19L241.51 83.57V83.59C242.05 83.22 242.83 83.25 243.69 83.74L430.88 191.81C432.42 192.7 433.58 194.97 433.31 196.56L409.7 336.63C409.58 337.36 409.22 337.84 408.71 338.06L405.94 339.66L405.46 337.07L405.62 337.12L219.56 229.7C218.02 228.81 216.86 226.54 217.13 224.95L217.14 224.94Z",
    fill: "url(#paint5_linear_2513_30134)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.83 195.6L432.91 194.24C433.26 195.03 433.42 195.86 433.31 196.56L409.7 336.63C409.58 337.36 409.22 337.84 408.71 338.06L405.94 339.66L405.46 337.07L405.62 337.12L396.21 331.68L429.83 195.61V195.6Z",
    fill: "url(#paint6_linear_2513_30134)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.63 231.38L403.82 339.45C405.27 340.28 406.5 339.8 406.76 338.31L430.37 198.24C430.64 196.65 429.48 194.37 427.94 193.49L240.75 85.41C239.3 84.58 238.07 85.06 237.81 86.55L214.2 226.62C213.93 228.21 215.09 230.49 216.63 231.37V231.38Z",
    fill: "#0F6F00"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.51
  }, /*#__PURE__*/React.createElement("path", {
    d: "M243.2 94.35L423.63 198.53L401.26 330.44L220.94 226.33L243.2 94.35Z",
    fill: "#127403"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M289.17 445.02C287.56 445.02 285.88 444.62 284.54 443.85L85.34 328.8C83.98 328.01 83.2 326.94 83.2 325.85C83.2 324.92 83.76 324.08 84.78 323.49L210.51 250.9C212.67 249.65 216.3 249.79 218.77 251.22L417.97 366.27C419.33 367.06 420.11 368.13 420.11 369.22C420.11 370.15 419.55 370.99 418.53 371.58L292.8 444.17C291.81 444.74 290.52 445.02 289.17 445.02ZM214.13 250.98C212.95 250.98 211.82 251.22 210.98 251.7L85.25 324.29C84.52 324.71 84.14 325.24 84.14 325.84C84.14 326.58 84.75 327.36 85.81 327.98L285.01 443.03C287.18 444.28 290.47 444.43 292.33 443.35L418.06 370.76C418.79 370.34 419.17 369.81 419.17 369.22C419.17 368.47 418.56 367.7 417.5 367.08L218.3 252.03C217.1 251.34 215.57 250.99 214.13 250.99V250.98Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M100.55 327.21L285.84 434.19C287.87 435.36 290.94 435.49 292.69 434.47L403.26 370.63C405.02 369.62 404.8 367.84 402.77 366.67L217.48 259.69C215.45 258.52 212.38 258.39 210.63 259.41L100.06 323.25C98.3 324.26 98.52 326.04 100.55 327.21Z",
    fill: "#0F6F00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.97 297.69L109.19 303.03L211.62 243.89C213.33 242.9 216.33 243.02 218.31 244.17L394.98 346.17C396.67 345.22 404.38 341.52 404.38 341.52L400.64 351.26C400.64 351.26 400.63 351.25 400.62 351.25C400.47 351.68 400.13 352.09 399.57 352.41L291.69 414.7C289.98 415.69 286.98 415.57 285 414.42L104.21 310.04C103.4 309.57 102.9 309 102.69 308.43H102.68L98.96 297.7L98.97 297.69Z",
    fill: "url(#paint7_linear_2513_30134)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.55 299.37L285.84 406.35C287.87 407.52 290.94 407.65 292.69 406.63L403.26 342.79C405.02 341.78 404.8 340 402.77 338.83L217.48 231.85C215.45 230.68 212.38 230.55 210.63 231.57L100.06 295.41C98.3 296.42 98.52 298.2 100.55 299.37Z",
    fill: "url(#paint8_linear_2513_30134)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.72 383.2V381.17C341.72 380.98 341.6 380.89 341.46 380.97L334.29 385.11C334.15 385.19 334.03 385.42 334.03 385.61V387.64C334.03 387.83 334.15 387.92 334.29 387.84L341.46 383.7C341.6 383.62 341.72 383.39 341.72 383.2Z",
    fill: "#0F6F00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331 389.39V387.36C331 387.17 330.88 387.08 330.74 387.16L323.57 391.3C323.43 391.38 323.31 391.61 323.31 391.8V393.83C323.31 394.02 323.43 394.11 323.57 394.03L330.74 389.89C330.88 389.81 331 389.58 331 389.39Z",
    fill: "#0F6F00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.43 336.81L220.46 247.91C219.43 247.32 218.17 247.32 217.14 247.91L162.31 279.63C161.52 280.09 161.52 281.22 162.31 281.68L316.21 370.54C317.24 371.13 318.5 371.13 319.52 370.54L374.42 338.86C375.21 338.41 375.21 337.27 374.42 336.81H374.43Z",
    fill: "#0F6F00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.43 338.86L373.88 339.18L220.46 250.6C219.43 250.01 218.17 250.01 217.14 250.6L162.86 282L162.31 281.68C161.52 281.23 161.52 280.09 162.31 279.63L217.14 247.91C218.17 247.32 219.43 247.32 220.46 247.91L374.43 336.81C375.22 337.27 375.22 338.4 374.43 338.86Z",
    fill: "#0F6F00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213 255.95L346.75 333.17L352.69 329.74L218.94 252.52L213 255.95Z",
    fill: "#0F6F00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.42 264.37L323.87 336.8L329.82 333.36L204.37 260.93L198.42 264.37Z",
    fill: "#0F6F00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.92 269.85L336.63 355.13L342.57 351.69L194.87 266.42L188.92 269.85Z",
    fill: "#0F6F00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.43 275.33L327.13 360.61L333.08 357.18L185.37 271.9L179.43 275.33Z",
    fill: "#0F6F00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.93 280.82L317.63 366.09L323.58 362.66L175.88 277.38L169.93 280.82Z",
    fill: "#0F6F00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.83 337.84L360.77 341.27L366.72 337.84L360.77 334.4L354.83 337.84Z",
    fill: "#0F6F00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.85 342.56L346.19 349.69L352.14 346.25L339.8 339.13L333.85 342.56Z",
    fill: "#0F6F00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.52 358.32L173 334.35C171.38 333.41 171.38 331.89 173 330.96L201.39 314.57C203.01 313.63 205.64 313.63 207.27 314.57L248.79 338.54C250.41 339.48 250.41 341 248.79 341.93L220.4 358.32C218.78 359.26 216.15 359.26 214.52 358.32Z",
    fill: "url(#paint9_linear_2513_30134)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.79 339.93L207.27 315.96C205.65 315.02 203.02 315.02 201.39 315.96L173 332.35C172.5 332.64 172.17 332.99 171.98 333.35C171.55 332.53 171.88 331.61 173 330.96L201.39 314.57C203.01 313.63 205.64 313.63 207.27 314.57L248.79 338.54C249.91 339.19 250.24 340.11 249.81 340.93C249.62 340.56 249.29 340.22 248.79 339.93Z",
    fill: "#0F6F00"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.11
  }, /*#__PURE__*/React.createElement("path", {
    d: "M217.29 231.64L402.58 338.62C404.61 339.79 407.68 339.92 409.43 338.9L520 275.06C521.76 274.05 521.54 272.27 519.51 271.1L334.22 164.12C332.19 162.95 329.12 162.82 327.37 163.84L216.8 227.68C215.04 228.69 215.26 230.47 217.29 231.64Z",
    fill: "url(#paint10_linear_2513_30134)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.13 250.82L361.61 226.85C359.99 225.91 359.99 224.39 361.61 223.46L390 207.07C391.62 206.13 394.25 206.13 395.88 207.07L437.4 231.04C439.02 231.98 439.02 233.5 437.4 234.43L409.01 250.82C407.39 251.76 404.76 251.76 403.13 250.82Z",
    fill: "url(#paint11_linear_2513_30134)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.4 232.42L395.88 208.45C394.26 207.51 391.63 207.51 390 208.45L361.61 224.84C361.11 225.13 360.78 225.48 360.59 225.84C360.16 225.02 360.49 224.1 361.61 223.45L390 207.06C391.62 206.12 394.25 206.12 395.88 207.06L437.4 231.03C438.52 231.68 438.85 232.6 438.42 233.42C438.23 233.05 437.9 232.71 437.4 232.42Z",
    fill: "#0F6F00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.65 288.28L301.68 199.38C300.65 198.79 299.39 198.79 298.36 199.38L243.53 231.1C242.74 231.56 242.74 232.69 243.53 233.15L397.43 322.01C398.46 322.6 399.72 322.6 400.74 322.01L455.64 290.33C456.43 289.88 456.43 288.74 455.64 288.28H455.65Z",
    fill: "#0F6F00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.65 290.32L455.1 290.64L301.68 202.06C300.65 201.47 299.39 201.47 298.36 202.06L244.08 233.46L243.53 233.14C242.74 232.69 242.74 231.55 243.53 231.09L298.36 199.37C299.39 198.78 300.65 198.78 301.68 199.37L455.65 288.27C456.44 288.73 456.44 289.86 455.65 290.32Z",
    fill: "#0F6F00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.88 228.94L392.01 306.39L386.7 309.45L252.56 232.01L257.88 228.94Z",
    fill: "#0F6F00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.01 220.78L399.5 294.39L394.19 297.46L266.7 223.85L272.01 220.78Z",
    fill: "#0F6F00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.02 299.89L420.93 306.76L415.62 309.83L403.71 302.96L409.02 299.89Z",
    fill: "#0F6F00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.51 310.14L406.8 314.92L401.49 317.99L393.19 313.2L398.51 310.14Z",
    fill: "#0F6F00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.86 215.67L429.79 301.65L424.47 304.72L275.55 218.74L280.86 215.67Z",
    fill: "#0F6F00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.72 210.56L438.64 296.54L433.33 299.6L284.41 213.62L289.72 210.56Z",
    fill: "#0F6F00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.58 205.44L447.5 291.42L442.19 294.49L293.26 208.51L298.58 205.44Z",
    fill: "#0F6F00"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.42,
    d: "M303.08 328.89L343 304.33L253.25 252.52L210.9 280.99L303.08 328.89Z",
    fill: "url(#paint12_radial_2513_30134)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.42,
    d: "M343 304.33L352.14 246.57L267.92 198.26V260.87L343 304.33Z",
    fill: "url(#paint13_radial_2513_30134)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M349.55 175.15L340.01 169.73L340.34 167.67L349.88 173.09L349.55 175.15Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M354.45 177.94L351.01 175.98L351.33 173.92L354.77 175.87L354.45 177.94Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M358.24 180.09L355.9 178.77L356.23 176.7L358.56 178.03L358.24 180.09Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M344.47 177.4L339.27 174.44L339.6 172.38L344.8 175.34L344.47 177.4Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M352.3 181.85L345.93 178.23L346.25 176.16L352.62 179.79L352.3 181.85Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M356.09 184.01L353.76 182.68L354.08 180.62L356.41 181.94L356.09 184.01Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M359.7 186.06L357.36 184.73L357.69 182.67L360.02 183.99L359.7 186.06Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.29 181.3L338.53 179.16L338.86 177.09L342.62 179.23L342.29 181.3Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.04 182.86L343.75 182.12L344.08 180.06L345.36 180.79L345.04 182.86Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M348.83 185.01L346.49 183.68L346.82 181.62L349.15 182.95L348.83 185.01Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M351.67 191.76L337.79 183.87L338.12 181.81L352 189.7L351.67 191.76Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M356.56 194.55L353.13 192.59L353.45 190.53L356.89 192.48L356.56 194.55Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M340.81 190.72L337.05 188.58L337.38 186.52L341.14 188.66L340.81 190.72Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M349.64 195.74L342.27 191.55L342.59 189.49L349.96 193.68L349.64 195.74Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M353.43 197.9L351.1 196.57L351.42 194.51L353.75 195.84L353.43 197.9Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M344.01 197.67L336.31 193.3L336.64 191.23L344.33 195.61L344.01 197.67Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.03 201.67L345.46 198.5L345.79 196.44L351.35 199.6L351.03 201.67Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M356.25 204.63L352.49 202.5L352.81 200.43L356.57 202.57L356.25 204.63Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M338.17 199.49L335.57 198.01L335.9 195.95L338.49 197.43L338.17 199.49Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M343.06 202.27L339.63 200.32L339.95 198.26L343.39 200.21L343.06 202.27Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M350.05 206.25L344.52 203.1L344.84 201.04L350.38 204.18L350.05 206.25Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M342.79 207.25L334.83 202.73L335.15 200.66L343.12 205.19L342.79 207.25Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M351.71 212.32L344.25 208.08L344.57 206.02L352.03 210.26L351.71 212.32Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.5 214.48L353.16 213.15L353.49 211.09L355.82 212.42L355.5 214.48Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M359.14 216.55L356.8 215.22L357.13 213.16L359.46 214.49L359.14 216.55Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M338.86 210.15L334.09 207.44L334.41 205.38L339.18 208.09L338.86 210.15Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.73 183.79L371.35 187.55L371.67 185.48L365.05 181.72L364.73 183.79Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M365.41 189.31L370.6 192.26L370.93 190.2L365.73 187.24L365.41 189.31Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M366.1 194.84L369.86 196.98L370.19 194.91L366.43 192.77L366.1 194.84Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M363.65 198.58L369.12 201.69L369.45 199.63L363.98 196.51L363.65 198.58Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M364.62 204.26L368.38 206.4L368.71 204.34L364.95 202.2L364.62 204.26Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M362.87 208.4L367.64 211.12L367.97 209.05L363.2 206.34L362.87 208.4Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M364.3 214.35L366.9 215.83L367.23 213.77L364.63 212.29L364.3 214.35Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M361.13 217.68L366.16 220.54L366.49 218.48L361.45 215.62L361.13 217.68Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M360.65 222.54L365.42 225.26L365.75 223.19L360.98 220.48L360.65 222.54Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M342.35 212.13L340.32 210.98L340.64 208.92L342.67 210.07L342.35 212.13Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M348.37 215.56L343.8 212.96L344.13 210.9L348.69 213.5L348.37 215.56Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M386.56 196.11L377.02 190.69L377.34 188.62L386.88 194.05L386.56 196.11Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M391.45 198.89L388.01 196.94L388.34 194.88L391.77 196.83L391.45 198.89Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.24 201.05L392.91 199.72L393.23 197.66L395.56 198.99L395.24 201.05Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M381.47 198.36L376.28 195.4L376.6 193.34L381.8 196.29L381.47 198.36Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M389.3 202.81L382.93 199.18L383.26 197.12L389.63 200.74L389.3 202.81Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.09 204.96L390.76 203.64L391.08 201.57L393.42 202.9L393.09 204.96Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M396.7 207.01L394.37 205.69L394.69 203.62L397.02 204.95L396.7 207.01Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M379.3 202.25L375.54 200.11L375.86 198.05L379.62 200.19L379.3 202.25Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M382.04 203.81L380.75 203.08L381.08 201.02L382.36 201.75L382.04 203.81Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M385.83 205.97L383.5 204.64L383.82 202.58L386.16 203.9L385.83 205.97Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M388.68 212.72L374.8 204.83L375.12 202.76L389 210.66L388.68 212.72Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M393.57 215.5L390.13 213.55L390.46 211.49L393.89 213.44L393.57 215.5Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M377.82 211.68L374.06 209.54L374.38 207.48L378.14 209.62L377.82 211.68Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M386.64 216.7L379.27 212.51L379.6 210.44L386.97 214.63L386.64 216.7Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M390.43 218.85L388.1 217.53L388.42 215.46L390.76 216.79L390.43 218.85Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.01 218.63L373.32 214.25L373.64 212.19L381.33 216.57L381.01 218.63Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M388.03 222.62L382.47 219.46L382.79 217.4L388.36 220.56L388.03 222.62Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M393.25 225.59L389.49 223.45L389.81 221.39L393.57 223.53L393.25 225.59Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M375.17 220.45L372.57 218.97L372.9 216.9L375.5 218.38L375.17 220.45Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M380.07 223.23L376.63 221.27L376.96 219.21L380.39 221.16L380.07 223.23Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.06 227.2L381.52 224.06L381.85 221.99L387.38 225.14L387.06 227.2Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M379.79 228.21L371.83 223.68L372.16 221.62L380.12 226.15L379.79 228.21Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M388.71 233.28L381.25 229.04L381.58 226.97L389.04 231.22L388.71 233.28Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M392.5 235.44L390.17 234.11L390.49 232.04L392.83 233.37L392.5 235.44Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M396.14 237.5L393.81 236.18L394.13 234.11L396.46 235.44L396.14 237.5Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M375.86 231.11L371.09 228.4L371.42 226.33L376.19 229.04L375.86 231.11Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.73 204.74L408.35 208.5L408.67 206.44L402.06 202.68L401.73 204.74Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M402.41 210.26L407.61 213.22L407.93 211.15L402.73 208.2L402.41 210.26Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M403.11 215.79L406.87 217.93L407.19 215.87L403.43 213.73L403.11 215.79Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M400.66 219.53L406.13 222.64L406.45 220.58L400.98 217.47L400.66 219.53Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M401.63 225.22L405.39 227.36L405.71 225.29L401.95 223.16L401.63 225.22Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M399.88 229.36L404.65 232.07L404.97 230.01L400.2 227.3L399.88 229.36Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M401.31 235.31L403.91 236.79L404.23 234.72L401.63 233.24L401.31 235.31Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M398.13 238.64L403.17 241.5L403.49 239.44L398.45 236.57L398.13 238.64Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M397.66 243.5L402.42 246.21L402.75 244.15L397.98 241.44L397.66 243.5Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.35 233.09L377.32 231.94L377.64 229.87L379.67 231.03L379.35 233.09Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M385.37 236.52L380.81 233.92L381.13 231.86L385.7 234.45L385.37 236.52Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M342.88 217.61L333.35 212.18L333.67 210.12L343.21 215.54L342.88 217.61Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M347.78 220.39L344.34 218.43L344.67 216.37L348.1 218.32L347.78 220.39Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M351.57 222.54L349.23 221.22L349.56 219.15L351.89 220.48L351.57 222.54Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M337.8 219.85L332.6 216.89L332.93 214.83L338.13 217.79L337.8 219.85Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M345.63 224.3L339.26 220.68L339.58 218.62L345.95 222.24L345.63 224.3Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M349.42 226.46L347.09 225.13L347.41 223.07L349.74 224.39L349.42 226.46Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M353.03 228.51L350.69 227.18L351.02 225.12L353.35 226.45L353.03 228.51Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M335.62 223.75L331.86 221.61L332.19 219.54L335.95 221.68L335.62 223.75Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M338.37 225.31L337.08 224.58L337.41 222.51L338.69 223.24L338.37 225.31Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M342.16 227.46L339.82 226.14L340.15 224.07L342.48 225.4L342.16 227.46Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M345 234.22L331.12 226.32L331.45 224.26L345.33 232.15L345 234.22Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M349.9 237L346.46 235.04L346.79 232.98L350.22 234.93L349.9 237Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M334.14 233.17L330.38 231.04L330.71 228.97L334.47 231.11L334.14 233.17Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M342.97 238.19L335.6 234L335.93 231.94L343.29 236.13L342.97 238.19Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M346.76 240.35L344.43 239.02L344.75 236.96L347.09 238.29L346.76 240.35Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M337.34 240.12L329.64 235.75L329.97 233.69L337.66 238.06L337.34 240.12Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M344.36 244.12L338.79 240.95L339.12 238.89L344.68 242.05L344.36 244.12Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M349.58 247.09L345.82 244.95L346.14 242.88L349.9 245.02L349.58 247.09Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M331.5 241.94L328.9 240.46L329.23 238.4L331.83 239.88L331.5 241.94Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M336.39 244.72L332.96 242.77L333.28 240.71L336.72 242.66L336.39 244.72Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M343.38 248.7L337.85 245.55L338.17 243.49L343.71 246.63L343.38 248.7Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M336.12 249.7L328.16 245.18L328.49 243.11L336.45 247.64L336.12 249.7Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M345.04 254.77L337.58 250.53L337.9 248.47L345.36 252.71L345.04 254.77Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M348.83 256.93L346.5 255.6L346.82 253.54L349.15 254.87L348.83 256.93Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M352.47 259L350.13 257.67L350.46 255.61L352.79 256.94L352.47 259Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M332.19 252.6L327.42 249.89L327.75 247.83L332.52 250.54L332.19 252.6Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M358.06 226.24L364.68 230L365 227.93L358.39 224.17L358.06 226.24Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M358.74 231.76L363.94 234.71L364.26 232.65L359.06 229.69L358.74 231.76Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M359.43 237.29L363.2 239.43L363.52 237.36L359.76 235.22L359.43 237.29Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M356.98 241.03L362.45 244.14L362.78 242.08L357.31 238.97L356.98 241.03Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M357.95 246.71L361.71 248.85L362.04 246.79L358.28 244.65L357.95 246.71Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M356.2 250.85L360.97 253.57L361.3 251.5L356.53 248.79L356.2 250.85Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M357.63 256.8L360.23 258.28L360.56 256.22L357.96 254.74L357.63 256.8Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M354.46 260.13L359.49 262.99L359.82 260.93L354.78 258.07L354.46 260.13Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M353.98 265L358.75 267.71L359.08 265.64L354.31 262.93L353.98 265Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M335.68 254.58L333.65 253.43L333.97 251.37L336 252.52L335.68 254.58Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M341.7 258.01L337.13 255.41L337.46 253.35L342.02 255.95L341.7 258.01Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M343.32 273.87L335.62 269.48L335.94 267.42L343.65 271.8L343.32 273.87Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M348.6 276.87L345.56 275.14L345.89 273.08L348.92 274.8L348.6 276.87Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M379.89 238.56L370.35 233.14L370.67 231.07L380.21 236.5L379.89 238.56Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M384.78 241.34L381.35 239.39L381.67 237.33L385.1 239.28L384.78 241.34Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M388.57 243.5L386.24 242.17L386.56 240.11L388.9 241.44L388.57 243.5Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M374.81 240.81L369.61 237.85L369.93 235.79L375.13 238.74L374.81 240.81Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M382.63 245.26L376.26 241.63L376.59 239.57L382.96 243.19L382.63 245.26Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M386.42 247.41L384.09 246.09L384.41 244.02L386.75 245.35L386.42 247.41Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M390.03 249.46L387.7 248.14L388.02 246.07L390.36 247.4L390.03 249.46Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M372.63 244.7L368.87 242.56L369.19 240.5L372.95 242.64L372.63 244.7Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M375.37 246.26L374.09 245.53L374.41 243.47L375.7 244.2L375.37 246.26Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M379.16 248.42L376.83 247.09L377.15 245.03L379.49 246.35L379.16 248.42Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M382.01 255.17L368.13 247.28L368.45 245.21L382.33 253.11L382.01 255.17Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M386.9 257.95L383.47 256L383.79 253.94L387.22 255.89L386.9 257.95Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M371.15 254.13L367.39 251.99L367.71 249.93L371.47 252.07L371.15 254.13Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M379.97 259.15L372.6 254.96L372.93 252.9L380.3 257.09L379.97 259.15Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M383.76 261.3L381.43 259.98L381.75 257.91L384.09 259.24L383.76 261.3Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M374.34 261.08L366.65 256.7L366.97 254.64L374.67 259.02L374.34 261.08Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M381.36 265.07L375.8 261.91L376.12 259.85L381.69 263.01L381.36 265.07Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M386.58 268.04L382.82 265.9L383.14 263.84L386.9 265.98L386.58 268.04Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M368.5 262.9L365.91 261.42L366.23 259.35L368.83 260.83L368.5 262.9Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M373.4 265.68L369.96 263.73L370.29 261.66L373.72 263.61L373.4 265.68Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M380.39 269.65L374.85 266.51L375.18 264.44L380.71 267.59L380.39 269.65Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M373.13 270.66L365.17 266.13L365.49 264.07L373.45 268.6L373.13 270.66Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M382.04 275.73L374.58 271.49L374.91 269.42L382.37 273.67L382.04 275.73Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M385.83 277.89L383.5 276.56L383.82 274.5L386.16 275.82L385.83 277.89Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M389.47 279.96L387.14 278.63L387.46 276.56L389.8 277.89L389.47 279.96Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M369.19 273.56L364.43 270.85L364.75 268.78L369.52 271.49L369.19 273.56Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M395.07 247.19L401.68 250.95L402 248.89L395.39 245.13L395.07 247.19Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M395.74 252.71L400.94 255.67L401.26 253.6L396.07 250.65L395.74 252.71Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M396.44 258.24L400.2 260.38L400.52 258.32L396.76 256.18L396.44 258.24Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M393.99 261.98L399.46 265.1L399.78 263.03L394.31 259.92L393.99 261.98Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M394.96 267.67L398.72 269.81L399.04 267.75L395.28 265.61L394.96 267.67Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M393.21 271.81L397.98 274.52L398.3 272.46L393.53 269.75L393.21 271.81Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M394.64 277.76L397.24 279.24L397.56 277.17L394.96 275.69L394.64 277.76Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M391.46 281.09L396.5 283.95L396.82 281.89L391.78 279.02L391.46 281.09Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M390.99 285.95L395.76 288.66L396.08 286.6L391.31 283.89L390.99 285.95Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M372.68 275.54L370.65 274.39L370.98 272.32L373 273.48L372.68 275.54Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M378.7 278.97L374.14 276.37L374.46 274.31L379.03 276.9L378.7 278.97Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M380.33 294.82L372.62 290.44L372.95 288.38L380.65 292.76L380.33 294.82Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M385.6 297.82L382.57 296.1L382.89 294.03L385.93 295.76L385.6 297.82Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M260.62 124.13L251.08 118.71L251.41 116.64L260.95 122.07L260.62 124.13Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M265.51 126.92L262.08 124.96L262.4 122.9L265.84 124.85L265.51 126.92Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M269.31 129.07L266.97 127.74L267.3 125.68L269.63 127.01L269.31 129.07Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M255.54 126.38L250.34 123.42L250.67 121.36L255.86 124.31L255.54 126.38Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M263.37 130.83L257 127.21L257.32 125.14L263.69 128.77L263.37 130.83Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M267.16 132.98L264.82 131.66L265.15 129.59L267.48 130.92L267.16 132.98Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M270.77 135.04L268.43 133.71L268.76 131.65L271.09 132.97L270.77 135.04Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.36 130.27L249.6 128.14L249.93 126.07L253.69 128.21L253.36 130.27Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.11 131.83L254.82 131.1L255.14 129.04L256.43 129.77L256.11 131.83Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M259.9 133.99L257.56 132.66L257.89 130.6L260.22 131.93L259.9 133.99Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M262.74 140.74L248.86 132.85L249.19 130.79L263.07 138.68L262.74 140.74Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M267.63 143.53L264.2 141.57L264.52 139.51L267.96 141.46L267.63 143.53Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M251.88 139.7L248.12 137.56L248.45 135.5L252.21 137.64L251.88 139.7Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M260.71 144.72L253.34 140.53L253.66 138.47L261.03 142.66L260.71 144.72Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M264.5 146.88L262.16 145.55L262.49 143.49L264.82 144.81L264.5 146.88Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M255.08 146.65L247.38 142.28L247.7 140.21L255.4 144.59L255.08 146.65Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.1 150.65L256.53 147.48L256.86 145.42L262.42 148.58L262.1 150.65Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M267.31 153.61L263.55 151.47L263.88 149.41L267.64 151.55L267.31 153.61Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M249.24 148.47L246.64 146.99L246.96 144.93L249.56 146.4L249.24 148.47Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M254.13 151.25L250.7 149.3L251.02 147.23L254.45 149.19L254.13 151.25Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M261.12 155.23L255.59 152.08L255.91 150.02L261.45 153.16L261.12 155.23Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M253.86 156.23L245.9 151.7L246.22 149.64L254.18 154.17L253.86 156.23Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M262.78 161.3L255.32 157.06L255.64 155L263.1 159.24L262.78 161.3Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.57 163.46L264.23 162.13L264.56 160.07L266.89 161.39L266.57 163.46Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M270.21 165.53L267.87 164.2L268.2 162.14L270.53 163.46L270.21 165.53Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M249.93 159.13L245.16 156.42L245.48 154.35L250.25 157.07L249.93 159.13Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.8 132.76L282.41 136.53L282.74 134.46L276.12 130.7L275.8 132.76Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M276.48 138.28L281.67 141.24L282 139.18L276.8 136.22L276.48 138.28Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M277.17 143.81L280.93 145.95L281.26 143.89L277.5 141.75L277.17 143.81Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M274.72 147.56L280.19 150.67L280.52 148.6L275.05 145.49L274.72 147.56Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M275.69 153.24L279.45 155.38L279.78 153.32L276.02 151.18L275.69 153.24Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M273.94 157.38L278.71 160.09L279.04 158.03L274.27 155.32L273.94 157.38Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M275.37 163.33L277.97 164.81L278.3 162.74L275.7 161.27L275.37 163.33Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M272.19 166.66L277.23 169.52L277.55 167.46L272.52 164.59L272.19 166.66Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M271.72 171.52L276.49 174.24L276.81 172.17L272.04 169.46L271.72 171.52Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M253.41 161.11L251.39 159.96L251.71 157.9L253.74 159.05L253.41 161.11Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M259.44 164.54L254.87 161.94L255.2 159.88L259.76 162.47L259.44 164.54Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M297.63 145.09L288.09 139.66L288.41 137.6L297.95 143.03L297.63 145.09Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M302.52 147.87L299.08 145.92L299.41 143.85L302.84 145.81L302.52 147.87Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.31 150.03L303.97 148.7L304.3 146.64L306.63 147.96L306.31 150.03Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M292.54 147.33L287.35 144.38L287.67 142.31L292.87 145.27L292.54 147.33Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M300.37 151.78L294 148.16L294.33 146.1L300.69 149.72L300.37 151.78Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.16 153.94L301.83 152.61L302.15 150.55L304.49 151.88L304.16 153.94Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M307.77 155.99L305.44 154.67L305.76 152.6L308.09 153.93L307.77 155.99Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M290.37 151.23L286.61 149.09L286.93 147.03L290.69 149.17L290.37 151.23Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M293.11 152.79L291.82 152.06L292.15 150L293.43 150.73L293.11 152.79Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M296.9 154.95L294.57 153.62L294.89 151.56L297.22 152.88L296.9 154.95Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M299.75 161.7L285.87 153.81L286.19 151.74L300.07 159.64L299.75 161.7Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M304.64 164.48L301.2 162.53L301.53 160.46L304.96 162.42L304.64 164.48Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M288.89 160.66L285.12 158.52L285.45 156.46L289.21 158.59L288.89 160.66Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M297.71 165.68L290.34 161.49L290.67 159.42L298.04 163.61L297.71 165.68Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M301.5 167.83L299.17 166.51L299.49 164.44L301.83 165.77L301.5 167.83Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.08 167.61L284.38 163.23L284.71 161.17L292.4 165.54L292.08 167.61Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M299.1 171.6L293.54 168.44L293.86 166.37L299.42 169.54L299.1 171.6Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M304.32 174.57L300.56 172.43L300.88 170.37L304.64 172.51L304.32 174.57Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M286.24 169.42L283.64 167.95L283.97 165.88L286.57 167.36L286.24 169.42Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M291.13 172.21L287.7 170.25L288.02 168.19L291.46 170.14L291.13 172.21Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.13 176.18L292.59 173.03L292.92 170.97L298.45 174.12L298.13 176.18Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M290.86 177.19L282.9 172.66L283.23 170.6L291.19 175.12L290.86 177.19Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M299.78 182.26L292.32 178.02L292.65 175.95L300.1 180.19L299.78 182.26Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M303.57 184.41L301.24 183.09L301.56 181.02L303.9 182.35L303.57 184.41Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M307.21 186.48L304.88 185.16L305.2 183.09L307.53 184.42L307.21 186.48Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M286.93 180.09L282.16 177.37L282.49 175.31L287.26 178.02L286.93 180.09Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.8 153.72L319.42 157.48L319.74 155.42L313.13 151.66L312.8 153.72Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M313.48 159.24L318.68 162.2L319 160.13L313.8 157.18L313.48 159.24Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M314.18 164.77L317.94 166.91L318.26 164.85L314.5 162.71L314.18 164.77Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M311.73 168.51L317.2 171.62L317.52 169.56L312.05 166.45L311.73 168.51Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M312.7 174.2L316.46 176.34L316.78 174.27L313.02 172.13L312.7 174.2Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M310.95 178.34L315.72 181.05L316.04 178.99L311.27 176.27L310.95 178.34Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M312.38 184.29L314.97 185.76L315.3 183.7L312.7 182.22L312.38 184.29Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M309.2 187.61L314.23 190.48L314.56 188.41L309.52 185.55L309.2 187.61Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M308.72 192.48L313.49 195.19L313.82 193.13L309.05 190.42L308.72 192.48Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.42 182.07L288.39 180.91L288.71 178.85L290.74 180L290.42 182.07Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M296.44 185.49L291.88 182.9L292.2 180.83L296.77 183.43L296.44 185.49Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M253.95 166.58L244.41 161.16L244.74 159.1L254.28 164.52L253.95 166.58Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M258.85 169.37L255.41 167.41L255.73 165.35L259.17 167.3L258.85 169.37Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M262.64 171.52L260.3 170.19L260.63 168.13L262.96 169.46L262.64 171.52Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M248.87 168.83L243.67 165.87L244 163.81L249.2 166.76L248.87 168.83Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M256.7 173.28L250.33 169.66L250.65 167.59L257.02 171.22L256.7 173.28Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M260.49 175.44L258.16 174.11L258.48 172.04L260.81 173.37L260.49 175.44Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M264.1 177.49L261.76 176.16L262.09 174.1L264.42 175.42L264.1 177.49Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M246.69 172.72L242.93 170.59L243.26 168.52L247.02 170.66L246.69 172.72Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M249.44 174.28L248.15 173.55L248.48 171.49L249.76 172.22L249.44 174.28Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M253.23 176.44L250.89 175.11L251.22 173.05L253.55 174.38L253.23 176.44Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M256.07 183.19L242.19 175.3L242.52 173.24L256.4 181.13L256.07 183.19Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M260.97 185.98L257.53 184.02L257.86 181.96L261.29 183.91L260.97 185.98Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M245.21 182.15L241.45 180.01L241.78 177.95L245.54 180.09L245.21 182.15Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M254.04 187.17L246.67 182.98L246.99 180.92L254.36 185.11L254.04 187.17Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M257.83 189.33L255.5 188L255.82 185.94L258.15 187.26L257.83 189.33Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M248.41 189.1L240.71 184.73L241.04 182.66L248.73 187.04L248.41 189.1Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M255.43 193.1L249.86 189.93L250.19 187.87L255.75 191.03L255.43 193.1Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M260.65 196.06L256.89 193.93L257.21 191.86L260.97 194L260.65 196.06Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M242.57 190.92L239.97 189.44L240.3 187.38L242.89 188.86L242.57 190.92Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M247.46 193.7L244.03 191.75L244.35 189.68L247.79 191.64L247.46 193.7Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M254.45 197.68L248.92 194.53L249.24 192.47L254.78 195.61L254.45 197.68Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M247.19 198.68L239.23 194.15L239.56 192.09L247.52 196.62L247.19 198.68Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M256.11 203.75L248.65 199.51L248.97 197.45L256.43 201.69L256.11 203.75Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M259.9 205.91L257.57 204.58L257.89 202.52L260.22 203.85L259.9 205.91Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M263.54 207.98L261.2 206.65L261.53 204.59L263.86 205.91L263.54 207.98Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M243.26 201.58L238.49 198.87L238.81 196.8L243.58 199.52L243.26 201.58Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M269.13 175.22L275.75 178.98L276.07 176.91L269.46 173.15L269.13 175.22Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M269.81 180.73L275 183.69L275.33 181.63L270.13 178.67L269.81 180.73Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M270.5 186.27L274.26 188.4L274.59 186.34L270.83 184.2L270.5 186.27Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M268.05 190.01L273.52 193.12L273.85 191.05L268.38 187.94L268.05 190.01Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M269.02 195.69L272.78 197.83L273.11 195.77L269.35 193.63L269.02 195.69Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M267.27 199.83L272.04 202.55L272.37 200.48L267.6 197.77L267.27 199.83Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M268.7 205.78L271.3 207.26L271.63 205.2L269.03 203.72L268.7 205.78Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M265.53 209.11L270.56 211.97L270.89 209.91L265.85 207.05L265.53 209.11Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M265.05 213.97L269.82 216.69L270.15 214.62L265.38 211.91L265.05 213.97Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M246.75 203.56L244.72 202.41L245.04 200.35L247.07 201.5L246.75 203.56Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M252.77 206.99L248.2 204.39L248.53 202.33L253.09 204.92L252.77 206.99Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M254.39 222.84L246.69 218.46L247.01 216.4L254.72 220.78L254.39 222.84Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M259.67 225.85L256.63 224.12L256.96 222.06L259.99 223.78L259.67 225.85Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M290.96 187.54L281.42 182.11L281.74 180.05L291.28 185.48L290.96 187.54Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M295.85 190.32L292.41 188.37L292.74 186.3L296.17 188.26L295.85 190.32Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M299.64 192.48L297.31 191.15L297.63 189.09L299.96 190.41L299.64 192.48Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M285.88 189.78L280.68 186.83L281 184.76L286.2 187.72L285.88 189.78Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M293.7 194.24L287.33 190.61L287.66 188.55L294.03 192.17L293.7 194.24Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M297.49 196.39L295.16 195.06L295.48 193L297.82 194.33L297.49 196.39Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M301.1 198.44L298.77 197.12L299.09 195.05L301.43 196.38L301.1 198.44Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M283.7 193.68L279.94 191.54L280.26 189.48L284.02 191.62L283.7 193.68Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M286.44 195.24L285.15 194.51L285.48 192.45L286.76 193.18L286.44 195.24Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M290.23 197.4L287.9 196.07L288.22 194.01L290.56 195.33L290.23 197.4Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M293.08 204.15L279.2 196.26L279.52 194.19L293.4 202.09L293.08 204.15Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M297.97 206.93L294.53 204.98L294.86 202.91L298.29 204.87L297.97 206.93Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M282.22 203.11L278.46 200.97L278.78 198.91L282.54 201.04L282.22 203.11Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M291.04 208.13L283.67 203.94L284 201.87L291.37 206.06L291.04 208.13Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M294.83 210.28L292.5 208.96L292.82 206.89L295.16 208.22L294.83 210.28Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M285.41 210.06L277.72 205.68L278.04 203.62L285.73 208L285.41 210.06Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M292.43 214.05L286.87 210.89L287.19 208.82L292.76 211.99L292.43 214.05Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M297.65 217.02L293.89 214.88L294.21 212.82L297.97 214.96L297.65 217.02Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M279.57 211.87L276.97 210.4L277.3 208.33L279.9 209.81L279.57 211.87Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M284.47 214.66L281.03 212.7L281.36 210.64L284.79 212.59L284.47 214.66Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M291.46 218.63L285.92 215.49L286.25 213.42L291.78 216.57L291.46 218.63Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M284.2 219.64L276.23 215.11L276.56 213.05L284.52 217.57L284.2 219.64Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M293.11 224.71L285.65 220.47L285.98 218.4L293.44 222.64L293.11 224.71Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M296.9 226.86L294.57 225.54L294.89 223.47L297.23 224.8L296.9 226.86Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M300.54 228.93L298.21 227.61L298.53 225.54L300.87 226.87L300.54 228.93Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M280.26 222.54L275.49 219.82L275.82 217.76L280.59 220.47L280.26 222.54Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M306.13 196.17L312.75 199.93L313.07 197.87L306.46 194.11L306.13 196.17Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M306.81 201.69L312.01 204.65L312.33 202.58L307.14 199.63L306.81 201.69Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M307.51 207.22L311.27 209.36L311.59 207.3L307.83 205.16L307.51 207.22Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M305.06 210.96L310.53 214.07L310.85 212.01L305.38 208.9L305.06 210.96Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M306.03 216.65L309.79 218.79L310.11 216.72L306.35 214.59L306.03 216.65Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M304.28 220.79L309.05 223.5L309.37 221.44L304.6 218.73L304.28 220.79Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M305.71 226.74L308.31 228.21L308.63 226.15L306.03 224.67L305.71 226.74Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M302.53 230.06L307.57 232.93L307.89 230.86L302.85 228L302.53 230.06Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M302.06 234.93L306.83 237.64L307.15 235.58L302.38 232.87L302.06 234.93Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M283.75 224.52L281.72 223.37L282.05 221.3L284.07 222.46L283.75 224.52Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M289.77 227.94L285.21 225.35L285.53 223.28L290.1 225.88L289.77 227.94Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M291.4 243.8L283.69 239.42L284.02 237.35L291.72 241.74L291.4 243.8Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M296.67 246.8L293.64 245.08L293.96 243.01L297 244.74L296.67 246.8Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.11 170.21L268.02 165.08C268.14 165.01 268.29 165.01 268.46 165.11L380.1 229.57C380.46 229.78 380.76 230.35 380.76 230.83V251.91C380.76 252.14 380.69 252.31 380.58 252.41C380.58 252.41 380.56 252.41 380.55 252.43L371.55 257.61L371.48 247.43L268.46 187.95C268.1 187.74 267.8 187.18 267.8 186.69V179.46L259.1 170.22L259.11 170.21Z",
    fill: "url(#paint14_linear_2513_30134)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.51 193.09L371.15 257.55C371.51 257.76 371.81 257.54 371.81 257.05V235.97C371.81 235.48 371.51 234.92 371.15 234.71L259.51 170.25C259.15 170.04 258.85 170.26 258.85 170.75V191.83C258.85 192.32 259.15 192.88 259.51 193.09Z",
    fill: "url(#paint15_linear_2513_30134)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M274.91 188.82L361.84 239.93C359.15 242.24 356.61 244.89 354.27 247.8L266.7 197.24C269.22 194.1 271.98 191.26 274.91 188.82Z",
    fill: "#0F6F00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.69 186.76L367.96 247.54C368.21 247.68 368.41 247.54 368.41 247.2V241.91C368.41 241.58 368.21 241.19 367.96 241.05L262.69 180.27C262.44 180.13 262.24 180.27 262.24 180.61V185.9C262.24 186.23 262.44 186.62 262.69 186.76Z",
    fill: "#0F6F00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.69 180.26L264.83 181.5V184.36C264.83 184.69 265.03 185.08 265.28 185.22L368.41 244.76V247.2C368.41 247.53 368.21 247.68 367.96 247.54L262.69 186.76C262.44 186.62 262.24 186.23 262.24 185.9V180.61C262.24 180.28 262.44 180.13 262.69 180.27V180.26Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.96,
    d: "M203.55 414.81L115.97 364.25C127.27 357.73 136.79 343.45 139.7 329.8C140.88 324.27 144.27 319.46 149.16 316.63L215.34 278.43C233.77 267.79 245.72 248.63 246.97 227.38C248.03 209.44 261.59 191.8 272.12 185.72L359.7 236.28C349.33 242.27 337.91 259 336.61 276.64C335.04 297.89 323.49 317.11 305.04 327.77L236.74 367.2C231.84 370.03 228.45 374.83 227.28 380.37C224.37 394.02 214.85 408.3 203.55 414.82V414.81Z",
    fill: "url(#paint16_linear_2513_30134)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M272.13 185.71L359.71 236.27C359.01 236.68 358.31 237.12 357.62 237.57L270.05 187C270.74 186.55 271.43 186.11 272.13 185.7V185.71Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.32
  }, /*#__PURE__*/React.createElement("path", {
    d: "M305.06 245.52L320.42 254.42L320.55 252.65L305.21 243.78L305.06 245.52Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.32 241.03L302.75 244.18L302.9 242.45L297.48 239.31L297.32 241.03Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.38 237.59L295.03 239.7L295.2 237.99L291.55 235.88L291.38 237.59Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.69 253.57L320.14 258.49L320.26 256.7L311.83 251.8L311.69 253.57Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.17 246.27L309.34 252.2L309.49 250.44L299.33 244.54L299.17 246.27Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.19 242.79L296.86 244.93L297.03 243.2L293.36 241.06L293.19 242.79Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.54 239.5L291.19 241.62L291.36 239.9L287.72 237.79L287.54 239.5Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.7 258.99L319.85 262.59L319.97 260.79L313.84 257.21L313.7 258.99Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.25 256.39L311.34 257.61L311.48 255.83L309.4 254.61L309.25 256.39Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.16 252.82L306.9 255.01L307.05 253.24L303.31 251.05L303.16 252.82Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.06 253.48L319.56 266.73L319.68 264.92L297.22 251.72L297.06 253.48Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.3 248.92L294.74 252.12L294.91 250.36L289.48 247.17L289.3 248.92Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.07 267.24L319.26 270.91L319.39 269.08L313.21 265.42L313.07 267.24Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.75 258.76L310.68 265.83L310.83 264.02L298.91 256.98L298.75 258.76Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.69 255.17L296.41 257.38L296.58 255.6L292.86 253.41L292.69 255.17Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.3 267.58L318.97 275.12L319.1 273.27L306.45 265.76L306.3 267.58Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.95 260.82L303.93 266.17L304.09 264.36L295.12 259.03L294.95 260.82Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.63 255.87L292.61 259.43L292.79 257.65L286.82 254.1L286.63 255.87Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.35 276.78L318.67 279.37L318.8 277.5L314.49 274.93L314.35 276.78Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.29 271.96L311.94 275.34L312.08 273.49L306.44 270.12L306.29 271.96Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.93 265.16L303.9 270.53L304.06 268.7L295.1 263.35L294.93 265.16Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.16 275.7L318.37 283.65L318.5 281.77L305.32 273.86L305.16 275.7Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.67 266.98L302.77 274.27L302.93 272.42L290.85 265.17L290.67 266.98Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.6 263.33L288.33 265.57L288.51 263.77L284.79 261.53L284.6 263.33Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.83 259.86L282.53 262.08L282.72 260.29L279.03 258.07L278.83 259.86Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.09 283.15L318.07 287.98L318.2 286.08L310.24 281.27L310.09 283.15Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.95 228.06L264.96 222.27L265.17 220.63L275.15 226.4L274.95 228.06Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.32 230.63L264.46 226.05L264.68 224.39L272.53 228.96L272.32 230.63Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.66 233.19L263.96 229.85L264.18 228.18L269.87 231.51L269.66 233.19Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.79 238.6L263.45 233.69L263.67 232.01L272 236.9L271.79 238.6Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.68 240.96L262.94 237.56L263.16 235.86L268.9 239.25L268.68 240.96Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.74 245.82L262.42 241.46L262.65 239.74L269.96 244.09L269.74 245.82Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.9 247.78L261.9 245.39L262.13 243.66L266.12 246.04L265.9 247.78Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.17 254.04L261.38 249.35L261.61 247.61L269.39 252.28L269.17 254.04Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.25 257.83L260.85 253.35L261.08 251.6L268.47 256.06L268.25 257.83Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.32 279.66L307.67 281.68L307.82 279.81L304.48 277.79L304.32 279.66Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.46 273.69L301.92 278.21L302.08 276.35L294.64 271.85L294.46 273.69Z",
    fill: "#127403"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.32
  }, /*#__PURE__*/React.createElement("path", {
    d: "M248.51 303.51L225.67 290.32L227.31 289.38L250.14 302.56L248.51 303.51Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.79 311.17L253.55 306.41L255.18 305.47L263.42 310.23L261.79 311.17Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.4 314.99L265.98 313.59L267.62 312.65L270.03 314.05L268.4 314.99Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.84 322.17L272.6 317.41L274.23 316.47L282.47 321.23L280.84 322.17Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.97 296.12L222.3 292.27L223.93 291.33L230.6 295.18L228.97 296.12Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.41 313.12L234.01 299.03L235.64 298.09L260.04 312.18L258.41 313.12Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.03 316.94L262.61 315.54L264.24 314.6L266.66 316L265.03 316.94Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.46 324.12L269.22 319.36L270.85 318.42L279.09 323.18L277.46 324.12Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.26 296.14L218.93 294.22L220.56 293.28L223.89 295.2L222.26 296.14Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.25 301.34L227.3 299.05L228.93 298.11L232.89 300.39L231.25 301.34Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.87 305.15L235.45 303.76L237.08 302.82L239.5 304.21L237.87 305.15Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.3 312.33L242.06 307.58L243.69 306.64L251.94 311.39L250.3 312.33Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.22 300.02L215.55 296.17L217.18 295.22L223.86 299.08L222.22 300.02Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.5 307.68L227.26 302.93L228.89 301.99L237.13 306.74L235.5 307.68Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.11 311.5L239.7 310.11L241.33 309.17L243.74 310.56L242.11 311.5Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.55 318.68L246.31 313.92L247.94 312.98L256.18 317.74L254.55 318.68Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.76 311.45L211.92 298.26L213.56 297.32L236.39 310.5L234.76 311.45Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.04 319.11L239.8 314.35L241.43 313.41L249.67 318.17L248.04 319.11Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.65 322.93L252.23 321.53L253.86 320.59L256.28 321.99L254.65 322.93Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.09 330.11L258.85 325.35L260.48 324.41L268.72 329.17L267.09 330.11Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.22 304.06L208.55 300.21L210.18 299.27L216.85 303.12L215.22 304.06Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.66 321.06L220.26 306.97L221.89 306.03L246.29 320.12L244.66 321.06Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.28 324.88L248.86 323.48L250.49 322.54L252.91 323.93L251.28 324.88Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.71 332.06L255.47 327.3L257.1 326.36L265.34 331.12L263.71 332.06Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.51 304.08L205.18 302.16L206.81 301.22L210.14 303.14L208.51 304.08Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.5 309.28L213.55 306.99L215.18 306.05L219.14 308.33L217.5 309.28Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.12 313.09L221.7 311.7L223.33 310.76L225.75 312.15L224.12 313.09Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.55 320.27L228.31 315.52L229.94 314.57L238.18 319.33L236.55 320.27Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.47 307.96L201.8 304.11L203.43 303.16L210.1 307.02L208.47 307.96Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.75 315.62L213.51 310.87L215.14 309.92L223.38 314.68L221.75 315.62Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.36 319.44L225.95 318.05L227.58 317.1L229.99 318.5L228.36 319.44Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.8 326.62L232.56 321.86L234.19 320.92L242.43 325.68L240.8 326.62Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.01 319.38L198.17 306.2L199.8 305.26L222.64 318.44L221.01 319.38Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.29 327.05L226.05 322.29L227.68 321.35L235.92 326.11L234.29 327.05Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.9 330.87L238.48 329.47L240.11 328.53L242.53 329.93L240.9 330.87Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.34 338.05L245.1 333.29L246.73 332.35L254.97 337.11L253.34 338.05Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.47 312L194.8 308.15L196.43 307.21L203.1 311.06L201.47 312Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.91 329L206.51 314.91L208.14 313.97L232.54 328.06L230.91 329Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.52 332.82L235.11 331.42L236.74 330.48L239.16 331.87L237.52 332.82Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.96 340L241.72 335.24L243.35 334.3L251.59 339.05L249.96 340Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.76 312.02L191.43 310.1L193.06 309.15L196.39 311.08L194.76 312.02Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.75 317.21L199.8 314.93L201.43 313.99L205.38 316.27L203.75 317.21Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.37 321.03L207.95 319.64L209.58 318.7L212 320.09L210.37 321.03Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.8 328.21L214.56 323.45L216.19 322.51L224.43 327.27L222.8 328.21Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.72 315.9L188.05 312.04L189.68 311.1L196.35 314.95L194.72 315.9Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208 323.56L199.76 318.8L201.39 317.86L209.63 322.62L208 323.56Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.61 327.38L212.2 325.98L213.83 325.04L216.24 326.44L214.61 327.38Z",
    fill: "#127403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.05 334.56L218.81 329.8L220.44 328.86L228.68 333.62L227.05 334.56Z",
    fill: "#127403"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M161.09 210.33L129.32 191.99L161.09 173.65L192.86 191.99L161.09 210.33ZM131.05 191.99L161.09 209.33L191.13 191.99L161.09 174.65L131.05 191.99Z",
    fill: "#0F6F00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.28 427.64L66.51 409.3L98.28 390.96L130.05 409.3L98.28 427.64ZM68.24 409.3L98.28 426.64L128.32 409.3L98.28 391.96L68.24 409.3Z",
    fill: "#0F6F00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.64 83.69L285.87 65.35L317.63 47L349.4 65.34L317.63 83.68L317.64 83.69ZM287.6 65.35L317.64 82.69L347.68 65.35L317.63 48L287.59 65.34L287.6 65.35Z",
    fill: "#0F6F00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.64 373.24L411.87 354.9L443.64 336.56L475.41 354.9L443.64 373.24ZM413.6 354.9L443.64 372.24L473.68 354.9L443.64 337.56L413.6 354.9Z",
    fill: "#0F6F00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2513_30134",
    x1: 115.3,
    y1: 204.74,
    x2: 45.13,
    y2: 261.02,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BCD5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#A2BDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#819FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#6A89FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#5B7CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5778FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2513_30134",
    x1: 451.179,
    y1: 408.144,
    x2: 370.36,
    y2: 420.546,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0D6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#C4DAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#D3E9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9FFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2513_30134",
    x1: 768.13,
    y1: 413.069,
    x2: 687.297,
    y2: 425.475,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17A800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#17A800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#17A800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#17A800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2513_30134",
    x1: 768.13,
    y1: 413.069,
    x2: 687.297,
    y2: 425.475,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17A800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#17A800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#17A800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#17A800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2513_30134",
    x1: 760.124,
    y1: 389.995,
    x2: 679.305,
    y2: 402.398,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0D6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#C4DAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#D3E9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9FFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2513_30134",
    x1: 433.34,
    y1: 211.49,
    x2: 217.1,
    y2: 211.49,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0D6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#C4DAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#D3E9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9FFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2513_30134",
    x1: 433.34,
    y1: 266.94,
    x2: 396.21,
    y2: 266.94,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17A800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#5B7CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#6A89FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#819FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#A2BDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCD5FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2513_30134",
    x1: 404.37,
    y1: 329.28,
    x2: 98.96,
    y2: 329.28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5778FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#5B7CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#6A89FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#819FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#A2BDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCD5FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2513_30134",
    x1: 301.75,
    y1: 319.1,
    x2: -3.81995,
    y2: 319.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0D6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#C4DAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#D3E9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9FFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2513_30134",
    x1: 250,
    y1: 336.45,
    x2: 171.79,
    y2: 336.45,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0D6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#C4DAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#D3E9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9FFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2513_30134",
    x1: 418.5,
    y1: 251.37,
    x2: 112.93,
    y2: 251.37,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0D6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#C4DAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#D3E9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9FFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2513_30134",
    x1: 438.61,
    y1: 228.94,
    x2: 360.39,
    y2: 228.94,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0D6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#C4DAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#D3E9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9FFFF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_2513_30134",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(315.36 290.71) rotate(180) scale(87.6 87.6)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B3AA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#182484"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_2513_30134",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(334.52 251.3) rotate(180) scale(67.05 67.05)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B3AA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#182484"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_2513_30134",
    x1: 358.66,
    y1: 270.65,
    x2: 299.6,
    y2: 164.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5778FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#5B7CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#6A89FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#819FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#A2BDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#BCD5FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_2513_30134",
    x1: 286.1,
    y1: 271.03,
    x2: 325.42,
    y2: 194.18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0D6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#C4DAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#D3E9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9FFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_2513_30134",
    x1: 179.84,
    y1: 409.18,
    x2: 304.79,
    y2: 187.78,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0D6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#C2D8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#CCE2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#DBF1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#E9FFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#D8EEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#CAE0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#C2D8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#C0D6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#D0E6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#E9FFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0D6FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2513_30134"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 442.665,
    height: 99.2883,
    fill: "white",
    transform: "translate(60)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2513_30134"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 550.51,
    height: 398.02,
    fill: "white",
    transform: "translate(0 47)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginPageImage);
export default __webpack_public_path__ + "static/media/login_page_image.67a935c69c6e03cd75228fc334225259.svg";
export { ForwardRef as ReactComponent };